import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';
import { bannerWidgetAdapter } from '../infra/adapters/bannerWidget.adapter';
import { createBannerWidgetService } from '../application/services/BannerWidgetService';

/**
 * Factory to wire PLP widget banner infrastructure -> application layer.
 */
export function bannerWidgetBuild(dispatch: AppDispatch) {
  return baseBuild(
    (dependency) => new bannerWidgetAdapter(dependency),
    (repo) => createBannerWidgetService(repo),
    dispatch
  );
}

